import { LoyaltyPostPurchaseBody } from './LoyaltyPostPurchaseBody';
import { LoyaltyPostPurchaseCTA } from './LoyaltyPostPurchaseCTA';
import { LoyaltyPostPurchaseHero } from './LoyaltyPostPurchaseHero';
import { LoyaltyPostPurchaseLink } from './LoyaltyPostPurchaseLink';
import { LoyaltyPostPurchaseModal } from './LoyaltyPostPurchaseModal';
import { LoyaltyPostPurchaseSubtitle } from './LoyaltyPostPurchaseSubtitle';
import { LoyaltyPostPurchaseTitle } from './LoyaltyPostPurchaseTitle';

export const LoyaltyPostPurchase = {
  Body: LoyaltyPostPurchaseBody,
  CTA: LoyaltyPostPurchaseCTA,
  Hero: LoyaltyPostPurchaseHero,
  Modal: LoyaltyPostPurchaseModal,
  Subtitle: LoyaltyPostPurchaseSubtitle,
  TextLink: LoyaltyPostPurchaseLink,
  Title: LoyaltyPostPurchaseTitle,
};
